import { Component, Input } from '@angular/core';
import { PrimeTemplate, TreeNode } from '@openng/optimus-ui/api';
import { ButtonComponent } from '../../../../components/kit/button/button.component';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { Tree } from '@openng/optimus-ui/tree';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-audit-log-tree',
    templateUrl: 'audit-log-tree.component.html',
    styleUrl: 'audit-log-tree.component.scss',
    imports: [
        ButtonComponent,
        Tooltip,
        TranslatePipe,
        Tree,
        PrimeTemplate,
        NgClass,
    ],
})
export class AuditLogTreeComponent {

    @Input() tree!: TreeNode[];
    @Input() entityName: string = '';

    public expand(expand: boolean = true) {
        this.expandTree(this.tree, expand);
    }

    private expandTree(nodes: TreeNode[], expand: boolean): void {
        nodes.forEach((it) => {
            it.expanded = expand;
            if (it.children?.length) {
                this.expandTree(it.children, expand);
            }
        });
    }

    protected readonly Array = Array;
}
